import React, { useState, useEffect } from 'react';
import styles from './Decarbonizator.module.scss';
import { useSearchParams } from 'react-router-dom';
import { Tabs } from 'tt-ui-lib/core';
import CaffeeTab from './Tabs/Cafee';
import FcemTab from './Tabs/Fcem';
import OffsetsTab from './Tabs/Offsets';

const tabs = [
  {
    name: 'TCC',
    id: 'caffee',
  },
  {
    name: 'FCEM',
    id: 'fcem',
  },
  {
    name: 'Offsets',
    id: 'offsets',
  },
];

export const Decarbonizator = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedChildTab, setSelectedChildTab] = useState(0);

  const handleChangeTabs = (newValue) => {
    if (!newValue && newValue !== 0) return;

    setSelectedTab(newValue);

    const menuItem = tabs[newValue];
    setSearchParams({ activeTab: menuItem.id });

    if (menuItem?.child) {
      setSelectedChildTab(0);
    } else {
      setSelectedChildTab(null);
    }
  };

  const handleChangeChildTabs = (newValue) => {
    if (!newValue && newValue !== 0) return;

    setSelectedChildTab(newValue);
  };

  useEffect(() => {
    if (searchParams.has('activeTab')) {
      const activeTabFromUrl = searchParams.get('activeTab');
      const activeTabIndex = tabs.findIndex((item) => item.id === activeTabFromUrl);

      if (activeTabIndex !== -1) {
        setSelectedTab(activeTabIndex);
      }
    }
  }, []);

  return (
    <div className={styles.content}>
      <div className={styles.titleBlock}>
        <h2>Decarbonizator</h2>
        <p>
          Here we offer a set of sustainability solutions related to elimination of carbon footprint
          which may be integrated into your business practices. We offer a range of rewards and
          incentives for your clients and end-customers which will keep them motivated to learn more
          and act on sustainability and will benefit your business by enhancing your brand
          reputation, customer loyalty and competitive advantage.
        </p>
      </div>

      <Tabs
        tabs={tabs}
        selectedTab={selectedTab}
        selectedChildTab={selectedChildTab}
        onChangeTab={handleChangeTabs}
        onChangeChildTab={handleChangeChildTabs}
      />

      <div>
        {selectedTab === 0 ? (
          <CaffeeTab />
        ) : selectedTab === 1 ? (
          <FcemTab />
        ) : selectedTab === 2 ? (
          <OffsetsTab />
        ) : null}
      </div>
    </div>
  );
};
